module.exports = __webpack_public_path__ + "static/media/DE.5c9661f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/DE.svg
// module id = 2138
// module chunks = 7